import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Components
import BodyWrap from '../utils/BodyWrap'
import UserNav from './UserNav'

// CSS
import '../../css/header/top-header.css'

const translationKey = 'app'

class TopHeader extends Component {
	render() {
		const { siteInfo, translationsLoading, translations } = this.props
		return (
			<div className='top-header'>
				{!translationsLoading && (
					<BodyWrap>
						<Link className='header-logo' to={'/'}>
							<img
								src={`/images/CCA-homepage-footer.png`}
								alt={!!siteInfo.site ? siteInfo.site.title : null}
							/>
						</Link>
						<div className='header-top-nav'>
							<h1>{translations.sections[translationKey].top_nav_title}</h1>
							<h2>{translations.sections[translationKey].top_nav_subtitle}</h2>

							<UserNav />
						</div>
					</BodyWrap>
				)}
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		siteInfo: state.siteInfo,
		translationsLoading:
			state.translations.isLoading[translationKey] === undefined
				? 1
				: state.translations.isLoading[translationKey],
		translations: state.translations.translations,
	}
}

export default connect(mapStateToProps)(TopHeader)



// WEBPACK FOOTER //
// ./src/components/header/TopHeader.js